module.exports = __webpack_public_path__ + "static/front-page-08-83543c5688578be5e2f4337479de422d.jpg";